import { getLocale } from "../runtime";

const sv_outofstock = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Slutsåld`
};

const outofstock = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_outofstock(inputs)
	return "outOfStock";
};

export { outofstock as "outOfStock" };